<template>
  <WebTop />
  <div id="body-wrap">

  <div class="home-block-title" style="margin-top: 24px;">
    <Icon type="ios-book-outline" color="#2d8cf0" /> <b style="color: #2d8cf0">提问</b>
  </div>

  <div class="question-detail-wrap">
    <Typography>
        <Title :level="3">{{ question.title }}</Title>
        <Paragraph>{{ question.content }}</Paragraph>
    </Typography>
  </div>

  <div class="home-block-title" style="margin-top: 24px;">
    <Icon type="ios-book-outline" color="#2d8cf0" /> <b style="color: #2d8cf0">回答</b>
  </div>
  <List item-layout="vertical"  style="padding: 12px; border: solid 1px #dcdee2; border-top: none;">
    <ListItem v-for="item in answers" :key="item.id">
      <ListItemMeta>
        <template #title>{{ item.content }}</template>
      </ListItemMeta>
      <!--最新帖子：{{item.content}}-->
      <template #action>
        <li>
          <Icon type="ios-chatbubbles-outline" /> 作者 <b>{{ item.createUserName }}</b>
        </li>
        <li>
          <Icon type="ios-thumbs-up-outline" /> 回复日期 <b>{{ item.createTime }}</b>
        </li>
      </template>
    </ListItem>
  </List>
  <div id="pager"><Page :total="answerNum" @on-change="pageChange" show-total /></div>

  <!---发帖--->
  <div id="thread-add-wrap">
    <div style="height: 30px; line-height: 30px; font-size: 18px;">回复</div>
    <div style="border: 1px solid #ccc; padding: 24px; padding-bottom: 0;">
      <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="0">
          <FormItem label="" prop="content">
              <Input v-model="formValidate.content" type="textarea" :rows="6" placeholder="回复内容"></Input>
          </FormItem>
          <FormItem>
              <Button type="primary" @click="handleSubmit('formValidate')">回答</Button>
          </FormItem>
      </Form>
    </div>
  </div>

</div>

</template>
<script>
import WebTop from '../../components/WebTop.vue'
import global from '../../utils/global'
import axios from 'axios'
export default {
  components: {
    WebTop
  },
  data () {
    return {
      user: null,

      workBriefings:[],
      page: 1,
      num: 0,
      question: {},
      answerNum: 0,
      answers: [],

      formValidate: {
        content: '',
        questionId: this.$route.query.id
      },
      ruleValidate: {
        content: [
            { required: true, message: '回复内容不能为空', trigger: 'blur' },
            { type: 'string', min: 20, message: '回复内容至少20个字', trigger: 'blur' }
        ]
      }
    }
  },
  mounted() {
    this.initUser()
    this.workBriefing()
  },
  methods: {
    //初始化用户信息
    initUser() {
      let userStr = localStorage.getItem("user")
      if(userStr!=null) {
        this.user = JSON.parse(userStr)
      }
    },


    workBriefing() {
      let vm = this
      let id = this.$route.query.id
      axios({
        method: 'post',
        url: global.restUrl + '/api/web/ask/v1.0/question/detail',
        data: {
          limit:10,
          page: vm.page,
          id: id
        }
      }).then(function (response) {
        let success = response.data.success
        if(success) {
          let data = response.data.data
          vm.question = data.question
          vm.answers = data.answers
          vm.answerNum = data.answerNum
        }
      });
    },
    pageChange(page) {
      this.page = page
      this.workBriefing()
    },
    handleSubmit (name) {
      this.$refs[name].validate((valid) => {
          if (valid) {
            let vm = this
            //let id = this.$route.query.id
            axios({
              method: 'post',
              url: global.restUrl + '/api/web/ask/v1.0/answer/save',
              data: vm.formValidate,
              headers: {
                token: vm.user.token
              }
            }).then(function (response) {
              let success = response.data.success
              if(success) {
                vm.$Message.success('提交成功，请等待管理员审核');
                vm.formValidate.content = ""
              }
            });
          } else {
              this.$Message.error('表单校验失败');
          }
      })
    },
  }
}
</script>
